module.exports = __webpack_public_path__ + "img/0.8bff9fd9.png";